import { render, staticRenderFns } from "./InvestorRelationsDetails.vue?vue&type=template&id=690a5627&scoped=true&"
import script from "./InvestorRelationsDetails.vue?vue&type=script&lang=js&"
export * from "./InvestorRelationsDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvestorRelationsDetails.vue?vue&type=style&index=0&id=690a5627&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a5627",
  null
  
)

export default component.exports